import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import "./ResultChart.css";
import "./DarkResult.css";
import axios from "axios";
import Chart from 'chart.js/auto';
import Dashboard from '../Dashboard/Dashboard';
import Subscriptions from "../Subscriptions/Subscriptions";
import ProgressBarNew from '../ProgressBarNew/ProgressBarNew';
import ResultTwo from '../ResultTwo/ResultTwo';
import ResultPageLast from '../ResultPageLast/ResultPageLast';
import { END_URL, IMG_URL } from "../../config";
import loadimg from "../../images/loader_wish.gif";
import black from "../../images/black.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import ResultChart from '../ResultChart/ResultChart';
import ResultSlider from '../ResultSlider/ResultSlider';

function AdminTest({ onLoginChange, testdata, globaltest }) {

    const navigate = useNavigate();
    const [Demension, setDemension] = useState([]);
    const [resultDetails, setResultDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [resultReady, setResultReady] = useState(false);
    const { result } = useParams();

    const [testData, settestData] = useState([]);

    const [Opacity, setOpacity] = useState(true);

    const [HavePastTest, setHavePastTest] = useState(false);

    // const [result_letter, setresult_letter] = useState("");

    const [SubPlan, setSubPlan] = useState({});

    const TestDone = useRef(null);

    const token = 'admin_token';

    // const result_letter = useMemo(() => {
    //     return testData?.data?.map((item) => ({
    //         final_letter: item.letter === 'left' ? item.leftletter : item.rightletter,
    //     })) || [];
    // }, [testData]);

    // const result_letter = useMemo(() => {
    //     return testData?.data?.map(item => ({
    //         final_letter: item.letter === 'left' ? item.leftletter || "" : item.rightletter || ""
    //     })) || [];
    // }, [testData]);

    const result_letter = useMemo(() => {
        if (!Array.isArray(testData?.data)) return [];
        
        return testData.data.map(item =>
            item?.letter === 'left' ? item?.leftletter || "" : item?.rightletter || ""
        );
    }, [testData]);


    useEffect(() => {

        setIsLoading(true);

        fetchResultData();

    }, []);


    const fetchResultData = async () => {

        try {
            setIsLoading(true);

            const response = await axios.post(`${END_URL}/admin-clusterdark/${result}`);
            const data = response.data;

            setDemension(data?.dimensions || []);
            setResultDetails(data?.result_details || []);
            // setresult_letter(data?.result_letter || []);

            const test = {
                test: {
                    id: data?.test?.id || null,
                    name: data?.test?.name || "",
                    type: data?.test?.type || "",
                    slug: data?.test?.slug || "",
                    test_slug: data?.data?.test_slug || "",
                    result_test_name:  data.test.result_test_name || ""
                }
            };

            const resultdata = {
                data: data?.data?.categoryresult?.map((item) => ({
                    category_id: item?.id || null,
                    left_result: item?.left_result || 0,
                    leftlabel: item?.resultcategory?.left_label || "",
                    leftletter: item?.resultcategory?.leftletter || "",
                    letter: item?.letter || "",
                    name: item?.name || "",
                    right_result: item?.right_result || 0,
                    rightlabel: item?.resultcategory?.right_label || "",
                    rightletter: item?.resultcategory?.rightletter || ""
                })) || []
            };

            const ConvertedtestData = {
                ...resultdata,
                result: data?.data?.result || null,
                ...test
            };

            settestData(ConvertedtestData);

        } catch (error) {
            console.error("Error fetching result:", error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (Demension && Object.keys(Demension).length > 0) {
            setResultReady(true);
        }
    }, [Demension]);

    const [tierData, setTierData] = useState([]);

        useEffect(() => {

        const fetchTiers = async () => {

            try {

            const res = await fetch(`${END_URL}/trait-tiers`);

            const data = await res.json();

            setTierData(data);
            } catch (err) {

            console.error("Failed to load tier data", err);
            }
        };

        fetchTiers();
    }, []);
    
    return (
        <div className="dark-main">
            {(isLoading || !resultReady)  ? (
                <div className="loader-container">
                    <img src={loadimg} alt="Loading..." className="loader-gif" />
                </div>
            ) : (
                <>
                  
                    { Demension && Object.keys(Demension).length > 0 && (

                        Demension.banner_image ? (

                            <ResultSlider dimension={Demension} />

                            )

                            :(

                            <div className="container-fluid dark-fluid1">

                                <div className="row">
                                
                                    <div className="dark-col" style={{ backgroundColor: Demension?.bg_image }}></div>

                                    <div className="row dark-row">
                                        <div className="col-12 col-md-7">
                                            <h1>
                                                {Demension?.name} <span>{result_letter}</span>
                                            </h1>
                                            <p>{Demension?.description}</p>
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <img src={`${IMG_URL}/d0/${Demension?.image}`} alt="" />
                                        </div>
                                    </div>
                                </div>

                            </div>

                        )
                    )}

                    <div className="container-fluid dark-fluid2 darkfluid-21">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-8 col-lg-8 dark-res admin-dark">

                                <div className="dark-inner-outer">

                                    {resultDetails && resultDetails.length > 0 &&
                                        <>

                                            <div className="dark-repeater final-col final-col-inner">
                                                {resultDetails.map((item) => (

                                                    <div className={`final-part1 ${item.content_type}`} key={item.id} dangerouslySetInnerHTML={{ __html: item.content }} />
                                                ))}

                                            </div>


                                            {testData?.test && result_letter.length > 0  && <ResultChart resultRef={TestDone} onLoginChange={onLoginChange} past_test={HavePastTest} subplan={SubPlan} token={token} result={result_letter} testdata={testData} tierData={tierData} demension={Demension} opacity={Opacity} />}

                                        </>
                                    }


                                    <div className='free-unpaid-res'>
                                        
                                            <ResultPageLast type="result" onLoginChange={onLoginChange}  token={token} payment={''} slug={''} demension={Demension}/>
                                            
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default AdminTest;
